import { Authentication as CoreAuthentication, LogOutReason } from "@iconics/core";
import { OktaAuth, TokenResponse } from "@okta/okta-auth-js";
import { appContext } from "../AppContext";

export class Authentication extends CoreAuthentication
{
    protected getStoredToken(): string
    {
        return appContext().localStorageProvider.getToken();
    }

    public setToken(value: string): void
    {
        appContext().localStorageProvider.setToken(value);
    }

    protected getProviderType(): string
    {
        return appContext().localStorageProvider.getUserDetails().providerType ?? '';
    }

    protected async refreshAadToken(): Promise<string>
    {
        try
        {
            const tokenResponse = await appContext().msalProvider.getToken();
            if (!tokenResponse.accessToken)
            {
                throw new Error('Failed to refresh AAD token.');
            }
            return tokenResponse.accessToken;
        }
        catch (tokenError)
        {
            throw new Error('Failed to refresh AAD token.');
        }
    }

    protected async refreshOktaToken(): Promise<string>
    {
        let tokenStorage = JSON.parse(localStorage.getItem("okta-token-storage") ?? "{}");
        const config =
        {
            issuer: tokenStorage.idToken.issuer,
            clientId: tokenStorage.idToken.clientId,
            redirectUri: window.location.origin + "/implicit/callback",
            scopes: ['openid', 'email', 'profile'],
        };

        let authClient = new OktaAuth(config);

        try
        {
            const tokenResponse: TokenResponse = await authClient.token.getWithoutPrompt();
            if (!tokenResponse?.tokens?.idToken?.idToken)
            {
                throw new Error('Failed to refresh OKTA token.');
            }

            authClient.tokenManager.setTokens(tokenResponse.tokens);
            return tokenResponse.tokens.idToken.idToken;
        }
        catch (error)
        {
            throw new Error('Failed to refresh OKTA token.');
        }
    }

    protected async refreshAuth0Token(): Promise<string>
    {
        try
        {
            const token = await appContext().auth0Provider.getToken();
            if (!token)
            {
                throw new Error('Failed to refresh Auth0 token.');
            }
            return token;
        }
        catch (error)
        {
            throw new Error('Failed to refresh Auth0 token.');
        }
    }

    public async clearStorage(): Promise<void>
    {
        const currentLanguage = appContext().language.current;
        appContext().sessionStorageProvider.clear();
        appContext().localStorageProvider.clear();
        appContext().cache.clearAll();
        await appContext().language.setCurrent(currentLanguage);
    }

    public async logOut(reason?: LogOutReason): Promise<void>
    {
        await this.clearStorage();
        window.location.href = `/login${reason ? '?reason=' + LogOutReason[reason] : ''}`;
    }
}
